// Cảnh báo khi hiện QR nạp tiền, dùng chung cho trang Thanh toán và dialog nạp nhanh:
//  1. Mã QR chỉ dùng 1 lần — có case user lưu lại ảnh QR cũ rồi chuyển tiền nhiều lần vào đó.
//  2. Không được sửa nội dung chuyển khoản — mất mã giao dịch thì không khớp được đơn.
// Cả hai case đều dẫn tới tiền không cộng tự động và phải nhờ CSKH đối soát tay.
import { AlertTriangle } from "lucide-react";

const WARNINGS: { headline: string; detail: string }[] = [
  {
    headline: "Mỗi mã QR chỉ chuyển tiền được 1 lần.",
    detail:
      "Đừng lưu lại ảnh QR để dùng cho lần sau — muốn nạp tiếp, hãy tạo mã QR mới. Tiền chuyển vào mã QR cũ sẽ không được cộng tự động.",
  },
  {
    headline: "Giữ nguyên nội dung chuyển khoản.",
    detail:
      "Nội dung là mã giao dịch, đã điền sẵn khi bạn quét QR. Nếu sửa, xoá hay thêm chữ vào nội dung, hệ thống không nhận ra đơn của bạn và tiền sẽ không được cộng tự động.",
  },
];

export function QrSingleUseWarning({ className }: { className?: string }) {
  return (
    <div
      role="alert"
      className={`flex items-start gap-2.5 rounded-2xl border border-amber-500/45 bg-amber-500/10 px-3.5 py-3 text-left ${className ?? ""}`}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
      <div className="space-y-1.5">
        {WARNINGS.map((w) => (
          <p key={w.headline} className="text-xs leading-5 text-amber-700 dark:text-amber-300">
            <span className="font-semibold">{w.headline}</span> {w.detail}
          </p>
        ))}
      </div>
    </div>
  );
}
